export function addDays(dt, nb) {
  return new Date(new Date(dt).setDate(new Date(dt).getDate() + nb))
}

export function dayToFrFormat(dt) {
  const options = { weekday: 'long', month: 'long', day: 'numeric' }
  return new Date(dt).toLocaleDateString('fr-FR', options)
}
